import {API_HEADERS_CONSTANTS, CookiesConstants, SSO_ROOT_ELEMENT} from "utils/constants";

type Method = "GET" | "POST" | "PUT" | "DELETE";
import {parseCookies} from "utils/nookies";
import { v4 as uuidv4 } from 'uuid';

import {
  AuthType, AuthV2Type,
  setLocalStorageAuthUser
  ,
} from "dataLayer/localStorage/localStorageMember";
import {
  resetClickStreamSearchID,
  resetClickStreamSearchSource
} from "../../libs/clickstream/helpers/clickStreamHelpers";
import Auth from "opensooq-sso";
import {getCustomThemeValue, isLoggedInMember} from "helpers/osHelpers";
import {SSO_LOGIN_STATE} from "contexts/authSSOContext";
import {jsonSafeGet} from "utils/Helpers";
import {EnumLoginState} from "../../hooks/useAuthSSO";
import EssentialData from "../../private/classes/EssentialData.class";

const LOCK_FETCHING_TOKEN_TIMEOUT = 2000;

interface IFetchAtClientSideProps {
  url: string;
  method?: Method;
  body?: any;
  type?: string;
  abortController?: any;
  checkErrCallback?: (response) => boolean;
  extraHeaders?: any;
  cb?: any;
}


export const generateRequiredCookies: (config?: {
  forceRefreshToken?: boolean;
  refreshReason?: string;
}) => Promise<AuthType> = async () => {

  const cookies = parseCookies();
  const source = cookies[CookiesConstants.SOURCE];
  const defaultCurrency = cookies[CookiesConstants.DEFAULT_CURRENCY];
  let sessionId = jsonSafeGet<any>(cookies[CookiesConstants.SESSION], {})?.id;
  let sessionStartedAt = Number(jsonSafeGet<any>(cookies[CookiesConstants.SESSION], {})?.startedAt)


  const deviceUUID = jsonSafeGet<AuthV2Type>(
      cookies[CookiesConstants.AUTH_V2]
  )?.deviceUUID;

  // if (!sessionId) {
  //   const trackingId = deviceUUID;
  //   let sessionIdPrefix =
  //       typeof trackingId == "string"
  //           ? trackingId.slice(0, trackingId.length * 0.5).replace("-", "")
  //           : trackingId + "-";
  //   sessionId = sessionId = sessionIdPrefix + uuidv4();
  //   sessionStartedAt = new Date().getTime();
  // }
  //
  // if (sessionId && ((new Date().getTime() - Number(sessionStartedAt)) / 60000) <= Number(process.env.NEXT_PUBLIC_SESSION_ID_EXPIRED_IN_MINUTES)) {
  //   setLocalStorageAuthUser({sessionId, sessionStartedAt: new Date().getTime()})
  // } else {
  //   setLocalStorageAuthUser({sessionId: null, sessionStartedAt: null})
  //   resetClickStreamSearchID()
  //   resetClickStreamSearchSource()
  //   sessionId = null;
  // }
  return {
    deviceUUID,
    source,
    sessionId,
    sessionStartedAt,
    defaultCurrency
  };

};

export async function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const getApiHeaders = async () => {
  const {
    source,
    deviceUUID,
    sessionId,
    defaultCurrency
  } = await generateRequiredCookies();

  while(!window[SSO_LOGIN_STATE]) {
    // sleep 5ms
    await sleep(5)
  }

  let authToken;
  if (window[SSO_LOGIN_STATE] && window[SSO_LOGIN_STATE].state === 'LoggedIn') {
    authToken = await Auth.getInstance().getToken(true);
  } else {
    authToken = await Auth.getInstance().getToken(false);
  }

  const cookies = parseCookies();
  let headers = {
    source,
    country:
      location.hostname.split(".")[0] !== "www" &&
      location.hostname.split(".")[0].length === 2
        ? location.hostname.split(".")[0]
        : process.env.NEXT_PUBLIC_DEFAULT_COUNTRY_CODE || "jo",
    "accept-language":
      document.location.pathname.match(/^\/(ar|en)/)?.[1] ||
      cookies[CookiesConstants.LOCALE],
    "release-version": API_HEADERS_CONSTANTS.RELEASE_VERSION,
  };

  headers = {
    ...headers,
    ...{
      Authorization: "Bearer " + authToken,
      "x-tracking-uuid": deviceUUID,
      "session-id": sessionId,
      "currency":defaultCurrency,
      "x-domain-theme": getCustomThemeValue('domainTheme'),
    },
  };

  return headers;
};

function _format_api_error(errorMessage, statusCode) {
  return {
    ...errorMessage,
    isValidationError: () => statusCode === 422,
    toValidationErrorMsg: () => {
      if (Array.isArray(errorMessage)) {
        return errorMessage.reduce((state, currentVal) => {
          state[currentVal.field] = currentVal.message;
          return state;
        }, {});
      } else {
        return errorMessage;
      }
    },
  };
}

async function handle401Error(response: Response): Promise<void> {
  const cookies = parseCookies();
  try {
    await Auth.getInstance().destroy();
  } catch (e) {
    console.log("failed to destroy",e);
  } finally {
    await Auth.getInstance().init(
      "opensooq.com",
      SSO_ROOT_ELEMENT,
      cookies[CookiesConstants.LOCALE],
      cookies[CookiesConstants.COUNTRY],
      cookies[CookiesConstants.SOURCE],
      cookies[CookiesConstants.DEVICE_UUID],
      cookies[CookiesConstants.CITY_ID]
    );
  }

  // let refreshReason: string = "401-error";
  //
  // function handleDeltaTimeError(wwwAuthHeader) {
  //   const csv = Object.fromEntries(
  //     wwwAuthHeader
  //       .replace("Bearer ", "")
  //       .split(",")
  //       .filter((a) => a)
  //       .map((e) =>
  //         e.split("=").map((b) => b.replace('"', "").replace('"', "").trim())
  //       )
  //   );
  //   const delta = Math.floor(parseInt(csv.time, 10) - Date.now() / 1000); // +;
  //   const isInvalidNumber = (val) => typeof val !== "number" || isNaN(val);
  //   window.adjustedTime = isInvalidNumber(delta) ? 0 : delta;
  //   refreshReason = isInvalidNumber(delta)
  //     ? refreshReason
  //     : "delta-time-error-401";
  // }
  //
  // function reAuth() {
  //   return (window.location.href = `/${getLang()}/logout?ref=forceLogout`);
  // }
  //
  // const wwwAuthHeader = response.headers.get("Www-Authenticate");
  //
  // if (Boolean(wwwAuthHeader)) {
  //   let invalidTokenError = wwwAuthHeader.includes("reauthenticate");
  //   if (invalidTokenError) {
  //     reAuth();
  //   } else {
  //     handleDeltaTimeError(wwwAuthHeader);
  //   }
  // }
  //
  // await generateRequiredCookiesAndGetToken({
  //   forceRefreshToken: true,
  //   refreshReason,
  // });
}

async function __fetch_with_error(
  url: string,
  abortController?: any,
  headers = {},
  body: any = null,
  method: Method = "GET",
  shouldHandle401: boolean = true
) {
  const config = {
    method,
    ...(method === "POST" ? { body: JSON.stringify(body) } : {}),
    credentials: "include",
    signal: undefined,
    headers,
  };
  if (abortController) {
    config.signal = abortController.signal;
  }
  // @ts-ignore
  const rawResponse = await fetch(url, config);
  const json = await rawResponse.json();
  if (rawResponse.status === 401 && shouldHandle401) {
    await handle401Error(rawResponse);
    const newHeaders = await getAuthenticatedHeaders();
    return __fetch_with_error(
      url,
      abortController,
      newHeaders,
      body,
      method,
      false
    );
  }
  if (rawResponse.status >= 400) {
    return Promise.reject(_format_api_error(json, rawResponse.status));
  }
  return json;
}

export async function __postApiClient<T>({
  url,
  body,
  extraHeaders = {},
  abortController = null,
}: IFetchAtClientSideProps): Promise<T> {
  let headers = await getApiHeaders();
  return __fetch_with_error(
    url,
    abortController,
    { ...headers, ...extraHeaders },
    body,
    "POST"
  );
}

export async function __getApiClient<T>(
  url: string,
  abortController?: any
): Promise<T> {
  const headers = await getApiHeaders();
  return __fetch_with_error(url, abortController, headers);
}

export function __getAjaxClient<T>(
  url: string,
  abortController?: any
): Promise<T> {
  url = `${process.env.NEXT_PUBLIC_AJAX_API}${url}`;
  return __fetch_with_error(url, abortController);
}

export function __postAjaxClient<T>(
  url: string,
  body: any,
  abortController?: any
): Promise<T> {
  url = `${process.env.NEXT_PUBLIC_AJAX_API}${url}`;
  return __fetch_with_error(url, abortController, {}, body, "POST");
}

export async function fetchAtClientSide<T>({
  url,
  body,
  method = "GET",
  type,
  abortController = null,
  checkErrCallback = (response) => response.status >= 400,
}: IFetchAtClientSideProps): Promise<T | Error> {
  if (url[0] === "/") {
    url = url.substring(1, url.length);
  }
  url = `${process.env.NEXT_PUBLIC_API_URL_CLIENT}/${url}`;

  if (method == "GET") {
    return __getApiClient(url, abortController);
  } else {
    const headers = await getApiHeaders();
    if (type?.toUpperCase() !== "FILE") {
      headers["Content-Type"] = "application/json";
    }
    if (type?.toUpperCase() === "SLR_OTP") {
      headers["abBucket"] = 1;
    }

    return new Promise((resolve, reject) => {
      const config = {
        method,
        body: type?.toUpperCase() === "FILE" ? body : JSON.stringify(body),
        cache: "no-cache",
        credentials: "include",
        signal: undefined,
        headers,
      };
      if (abortController) {
        config.signal = abortController.signal;
      }
      // @ts-ignore
      fetch(url, config)
        .then(async (response) => {
          const json = await response.json();
          if (checkErrCallback(response)) {
            return reject(_format_api_error(json, response.status));
          }
          resolve(json);
        })
        .catch((error) => {
          console.error("fetchAtClientSide Error:", method, url, error);
          reject(error as Error);
        });
    });
  }
}

export async function fetchAtClientSideV2<T>({
  url,
  body,
  method = "GET",
  type,
  abortController = null,
  checkErrCallback = (response) => response.status >= 400,
}: IFetchAtClientSideProps): Promise<T | Error> {
  if (method == "GET") {
    return __getApiClient(url, abortController);
  } else {
    const headers = await getApiHeaders();
    if (type?.toUpperCase() !== "FILE") {
      headers["Content-Type"] = "application/json";
    }
    if (type?.toUpperCase() === "SLR_OTP") {
      headers["abBucket"] = 1;
    }

    return new Promise((resolve, reject) => {
      const config = {
        method,
        body: type?.toUpperCase() === "FILE" ? body : JSON.stringify(body),
        cache: "no-cache",
        credentials: "include",
        signal: undefined,
        headers,
      };
      if (abortController) {
        config.signal = abortController.signal;
      }
      // @ts-ignore
      fetch(url, config)
        .then(async (response) => {
          const json = await response.json();
          if (checkErrCallback(response)) {
            return reject(_format_api_error(json, response.status));
          }
          resolve(json);
        })
        .catch((error) => {
          console.error("fetchAtClientSide Error:", method, url, error);
          reject(error as Error);
        });
    });
  }
}

export async function fetchVerticalAtClientSide<T>({
  url,
  abortController = null,
}: IFetchAtClientSideProps): Promise<T> {
  url = `${process.env.NEXT_PUBLIC_VERTICAL_API_URL_CLIENT}/${url}`;
  return __getApiClient(url, abortController);
}

// ----------------------------------------------------------------------
const _getAPIFullUrl = (url: string) => {
  if (url[0] === "/") {
    url = url.substring(1, url.length);
  }
  return `${process.env.NEXT_PUBLIC_API_URL_CLIENT}/${url}`;
};

const _generateHeaders = ({ authToken, source, deviceUUID, sessionId }) => {
  const cookies = parseCookies();
  return {
    source,
    country:
      location.hostname.split(".")[0] !== "www" &&
      location.hostname.split(".")[0].length === 2
        ? location.hostname.split(".")[0]
        : process.env.NEXT_PUBLIC_DEFAULT_COUNTRY_CODE || "jo",
    "accept-language":
      document.location.pathname.match(/^\/(ar|en)/)?.[1] ||
      cookies[CookiesConstants.LOCALE],
    "release-version": API_HEADERS_CONSTANTS.RELEASE_VERSION,
    Authorization: "Bearer " + authToken,
    "x-tracking-uuid": deviceUUID,
    "session-id": sessionId,
    "x-domain-theme": getCustomThemeValue("domainTheme"),
    "Content-Type": "application/json",
  };
};

export enum TypeUserStatus {
  AUTHENTICATED = "AUTHENTICATED",
  VERIFIED = "VERIFIED",
  ANONYMOUS = "ANONYMOUS",
}

export const fetchAPIswitcher = (userStatus: TypeUserStatus) => {
  switch (userStatus) {
    case TypeUserStatus.AUTHENTICATED:
      return fetchClientAuthenticated;
    case TypeUserStatus.VERIFIED:
      return fetchAtClientSide; // TODO: change to fetchClientVerified
    default:
      return fetchAtClientSide;
  }
};

export const fetchAPIswitcherV2 = (userStatus: TypeUserStatus) => {
  switch (userStatus) {
    case TypeUserStatus.AUTHENTICATED:
      return fetchClientAuthenticatedV2;
    case TypeUserStatus.VERIFIED:
      return fetchAtClientSideV2; // TODO: change to fetchClientVerified
    default:
      return fetchAtClientSideV2;
  }
};

export async function fetchClientAuthenticated<T>({
  url,
  body,
  method = "GET",
  cb = null,
}: IFetchAtClientSideProps): Promise<T | Error> {
  url = _getAPIFullUrl(url);
  const headers = await getAuthenticatedHeaders(cb);
  return __fetch_with_error(url, null, headers, body, method, true);
}

export async function fetchClientAuthenticatedV2<T>({
  url,
  body,
  method = "GET",
  cb = null,
}: IFetchAtClientSideProps): Promise<T | Error> {
  const headers = await getAuthenticatedHeaders(cb);
  return __fetch_with_error(url, null, headers, body, method, true);
}

const getAuthenticatedHeaders = async (cb=null) => {
  const { source, deviceUUID, sessionId ,defaultCurrency  } =
    await generateRequiredCookies();

  while (!window[SSO_LOGIN_STATE]) {
    // sleep 10ms
    await sleep(5);
  }

  const authToken = await Auth.getInstance()
    .getToken(true,false,cb)
    .then(async (token) => {
      if (window[SSO_LOGIN_STATE].state === EnumLoginState.LoggedOut) {
        document.dispatchEvent(
            new CustomEvent("on-login-success-api", {
              detail: {},
            })
        );
      }
      return token;
    });

  return _generateHeaders({ authToken, source, deviceUUID, sessionId });
};
